// Add this separately to fix the layout shifts once images arrive
window.addEventListener("load", () => {
  setTimeout(() => {
    ScrollTrigger.refresh();
  }, 0);
});

window.addEventListener("load", (event) => {
    gsap.registerPlugin(ScrollTrigger);
    // Initialize Lenis
    const lenis = new Lenis();

    // Use requestAnimationFrame to continuously update the scroll
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    // Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
    lenis.on('scroll', ScrollTrigger.update);

    // Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
    // This ensures Lenis's smooth scroll animation updates on each GSAP tick
    gsap.ticker.add((time) => {
      lenis.raf(time * 1000); // Convert time from seconds to milliseconds
    });

    // Disable lag smoothing in GSAP to prevent any delay in scroll animations
    gsap.ticker.lagSmoothing(0);

    requestAnimationFrame(raf);

    EqualWidth("footer summary");

    if ($(".hero_slider").length) {
      const hero_slider = new Swiper(".hero_slider", {
        slidesPerView: 1, // number, not string
        spaceBetween: 0,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
      });
    }

    if ($(".next_obsession_slider").length) {
      const next_obsession_slider = new Swiper(".next_obsession_slider", {
        slidesPerView: 4, // number, not string
        spaceBetween: 30,
        // autoplay: {
        //   delay: 2500,
        //   disableOnInteraction: false,
        // },
        // optionally enable navigation — DO add next/prev elements into HTML if you enable this
        navigation: {
          nextEl: ".next_obsession_slider_right",
          prevEl: ".next_obsession_slider_left",
        },
        pagination: {
          el: ".swiper-pagination",
          type: "progressbar",
        },
        on: {
          init: function () {
            console.log("Swiper initialized!");
            // your code here
            setTimeout(() => {
              EqualHeight(".next_obsession_slider .product_card");
            }, 100);
            setTimeout(() => {
              ScrollTrigger.refresh();
            }, 500);
          },
        },
        // responsive example (optional)
        breakpoints: {
          0: {
            slidesPerView: 1.5,
            centeredSlides: false,
            loop: false,
          },
          640: {
            slidesPerView: 2,
            centeredSlides: false,
            loop: false,
          },
          992: { slidesPerView: 3 },
          1200: { slidesPerView: 4 },
        },
      });

    }

    if ($(".gubb_favourites").length) {
      const tabs = document.querySelectorAll(".gubb_favourites .tabs .tab_name");
      const tabsContents = document.querySelectorAll(
        ".gubb_favourites .tabsContent"
      );

      const gubb_favourites = document.querySelector(".gubb_favourites");
      const tabsContanier = document.querySelector('.gubb_favourites .tabs');
      let threshold = 0.5;
      if(window.innerWidth <= 600){
        threshold = 0.8;
      }
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.intersectionRatio >= threshold) {
            tabsContanier.classList.add('active');
          } else {
            tabsContanier.classList.remove('active'); // optional
          }
        },
        {
          threshold: threshold
        }
      );
      observer.observe(gubb_favourites);

      tabs.forEach((html, index) => {
        html.addEventListener("mouseenter", () => {
          tabs.forEach((rhtml, rindex) => {
            rhtml.classList.remove("active");
            tabsContents[rindex].classList.remove("active");
          });
          html.classList.toggle("active");
          tabsContents[index].classList.toggle("active");
        });
      });

      const images = document.querySelectorAll(".parallax");
      new simpleParallax(document.querySelectorAll(".parallax"), {
        scale: 1,
        delay: 0.5,
      });
    }

    if ($(".gubb_gang").length) {
      const gubb_gang_slider = new Swiper(".gubb_gang_slider", {
        slidesPerView: 2.2, // number, not string
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        initialSlide: 2,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        // optionally enable navigation — DO add next/prev elements into HTML if you enable this
        navigation: {
          nextEl: ".gubb_gang_slider_right",
          prevEl: ".gubb_gang_slider_left",
        },
        on: {
          init: function () {
            console.log("Swiper initialized!");
            // your code here
            setTimeout(() => {
              EqualHeight(".gubb_gang_slider");
            }, 100);
            setTimeout(() => {
              ScrollTrigger.refresh();
            }, 500);
          },
        },
        // responsive example (optional)
        breakpoints: {
          0: { slidesPerView: 1.5 },
          640: { slidesPerView: 2 },
          992: { slidesPerView: 3 },
          1200: { slidesPerView: 5 },
        },
      });

      setTimeout(() => {
         EqualHeight(".gubb_gang_slider");
      }, 500);
      setTimeout(() => {
        ScrollTrigger.refresh();
      }, 500);
    }

    if ($(".good_vibes").length) {
      const section = document.querySelector(".good_vibes");
      const tabs = document.querySelectorAll(".good_vibes .tabs .tab_name");
      const tabsContents = document.querySelectorAll(".good_vibes .tab_content");

      tabs.forEach((html, index) => {
        html.classList.add(`tab-${index+1}`);
        html.style.zIndex = index + 1;
        tabsContents[index].classList.add(`tabsContent-${index+1}`);
        tabsContents[index].style.zIndex = 1;
      });

      const customCursor = document.querySelector(".vibesCursor");
      section.addEventListener("mouseenter", () => {
        customCursor.style.display = "block";
      });
      section.addEventListener("mouseleave", () => {
        customCursor.style.display = "none";
      });
      document.addEventListener("mousemove", (event) => {
        const { width, height } = customCursor.getBoundingClientRect();
        customCursor.style.left = `${event.clientX - width / 2}px`;
        customCursor.style.top = `${event.clientY - width / 2}px`;
      });

      document.addEventListener("scroll", () => {
        const rect = section.getBoundingClientRect();

        // If section is out of view, hide cursor
        if (rect.bottom < 0 || rect.top > window.innerHeight) {
          customCursor.style.display = "none";
        }
      });

      function scrollAnimation(){
        const anim = gsap.timeline();
        const startValue = 0;
        const endValue = tabs.length;

        anim.to(".tabsContent-2, .tab-2",
          {
            y: 0,
            fontWeight: 500,
            color: "#000"
          },
          "first"
        )
        .to(".tab-1",
          {
            fontWeight: 400,
            color: "rgba(0, 0, 0, 0.5019607843)"
          },
          "first"
        )
        .to(".tabsContent-3, .tab-3",
          {
            y: 0,
            fontWeight: 500,
            color: "#000"
          },
          "second"
        )
        .to(".tab-1, .tab-2",
          {
            fontWeight: 400,
            color: "rgba(0, 0, 0, 0.5019607843)"
          },
          "second"
        )
        .to(".tabsContent-4, .tab-4",
          {
            y: 0,
            fontWeight: 500,
            color: "#000"
          },
          "third"
        )
        .to(".tab-1, .tab-2, .tab-3",
          {
            fontWeight: 400,
            color: "rgba(0, 0, 0, 0.5019607843)"
          },
          "third"
        )

        ScrollTrigger.create({
          trigger: ".good_vibes_wrap",
          start: "top top",
          // end: "bottom top",
          end: "+=" + winH * 2,
          pin: true,
          scrub: true,
          // markers: true,
          animation: anim,
        });
      }

      let winW = window.innerWidth;
      let winH = window.innerHeight;

      function hoverAnimation() {
        const tabNames = document.querySelectorAll(".tabs .tab_name_desktop");
        const tabContentDesktops = document.querySelectorAll(".tab_content_desktop");

        console.log(tabContentDesktops,"tabContentDesktops");

        tabNames.forEach((element, index) => {
          element.addEventListener("mouseenter", () => {
            console.log(tabContentDesktops[0],index,"tabContentDesktops[index]");

            tabNames.forEach(el => el.classList.remove("active"));
            tabContentDesktops.forEach(el => el.classList.remove("active"));

            element.classList.add("active");

            tabContentDesktops.forEach((item, i) => {
              if (i <= index) {
                item.classList.add("active");
              }
            });
          });
        });
      }

      if(winW > 1024){
        // scrollAnimation();
        hoverAnimation();
      }else{
        tabs.forEach((html, index) => {
          html.addEventListener("click", () => {
            tabs.forEach((rhtml, rindex) => {
              rhtml.classList.remove("active");
              tabsContents[rindex].classList.remove("active");
            });
            html.classList.toggle("active");
            tabsContents[index].classList.toggle("active");
          });
        });
        
        let tabs_inner;
        let tab_content_mobile;
        let isSyncing = false; // 🔐 lock

        tabs_inner = new Swiper(".tabs_inner", {
          slidesPerView: 2, // number, not string
          spaceBetween: 20,
          slideToClickedSlide: true,
          on: {
            init(swiper) {
              EqualHeight(".tabs_inner .tab_name");
              // your code here
            },
            slideChange(swiper) {
              if (tab_content_mobile) {
                if (isSyncing) return;

                isSyncing = true;
                tab_content_mobile.slideToLoop(swiper.realIndex);

                setTimeout(() => {
                  isSyncing = false;
                }, swiper.params.speed);

              }
            },
          },
          // centeredSlides: true,
          // loop: true,
          // initialSlide: 2,
          // autoplay: {
          //   delay: 2500,
          //   disableOnInteraction: false,
          // },
        });

        tab_content_mobile = new Swiper(".tab_content_mobile", {
          slidesPerView: 1, // number, not string
          spaceBetween: 20,
          slideToClickedSlide: true,
          // allowTouchMove: false,
          // centeredSlides: true,
          // loop: true,
          // initialSlide: 2,
          // autoplay: {
          //   delay: 2500,
          //   disableOnInteraction: false,
          // },
          on: {
            slideChange(swiper) {
              if (isSyncing) return;

              isSyncing = true;
              tabs_inner.slideToLoop(swiper.realIndex);

              setTimeout(() => {
                isSyncing = false;
              }, swiper.params.speed);
            },
          },
        });

        // tabs_inner.controller.control = tab_content_mobile;
        // tab_content_mobile.controller.control = tabs_inner;
      }
    }

    if ($(".love_notes").length) {
      const love_notes_slider = new Swiper(".love_notes_slider", {
        slidesPerView: 4.5, // number, not string
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        initialSlide: 2,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        // responsive example (optional)
        breakpoints: {
          0: { slidesPerView: 1.5 },
          640: { slidesPerView: 2 },
          992: { slidesPerView: 3.5 },
          1200: { slidesPerView: 4.5 },
        },
      });
    }

    if ($(".love_notes").length) {
        // Optional: Handle window resize to keep it responsive
        $(window).resize(function() {
          $(".flipbook").turn("size", $(".flipbook-wrapper").width(), $(".flipbook-wrapper").height());
        });
    }

    if ($(".product_inside_hero_swiper").length) {
      const product_inside_hero_swiper = new Swiper(
        ".product_inside_hero_swiper",
        {
          slidesPerView: 2.5, // number, not string
          spaceBetween: 20,
          loop: true,
          pagination: {
            el: ".product_inside_hero .swiper-pagination",
            type: "progressbar",
          },
          navigation: {
            nextEl: ".product_inside_hero_swiper_right",
            prevEl: ".product_inside_hero_swiper_left",
          },
          mousewheel: {
            forceToAxis: true,     // vertical scroll → horizontal swiper
            sensitivity: 1,
            releaseOnEdges: true,  // allow page scroll on first/last slide
          },
          breakpoints: {
            0: {
              slidesPerView: 1.2,
              centeredSlides: true,
            },
            640: {},
            992: { centeredSlides: false },
            1200: { slidesPerView: 2.5 },
          },
        }
      );
    }

    if ($(".about_product").length) {
      function getColorByIndex(index, sequence) {
        return sequence[index % sequence.length];
      }
      const folderSequence = [
        "color_pink_light",
        "color_green_light",
        "color_purple_light",
        "color_yellow_light",
      ];
      let folderTagInners;
      let folderContent;

      if(window.outerWidth > 600){
        folderTagInners = document.querySelectorAll(".foldersWrap.desktop .folderTagInner");
        folderContent = document.querySelectorAll(".foldersWrap.desktop .folderContent");

        console.log(folderTagInners,"folderTagInners");
        folderContent.forEach(element => {
          console.log(element.getBoundingClientRect().height);
        });
        EqualHeight(".foldersWrap.desktop .folderContent");

        folderTagInners.forEach((item, index) => {
          const color = getColorByIndex(index, folderSequence);

          item.style.zIndex = folderTagInners.length - index;
          item.querySelector("svg .bg").style.fill = `var(--${color})`;
          folderContent[index].style.backgroundColor = `var(--${color})`;
          item.querySelector(".cross").style.backgroundColor = `var(--${color})`;

          item.addEventListener("click", () => {
            folderTagInners.forEach((el, i) => {
              el.classList.toggle("active", i === index);
              folderContent[i].classList.toggle("active", i === index);
            });
          });

          if (index !== 0) {
            item.style.left = `-${index * 50}px`;
            // item.style.paddingLeft = `${index * 30}px`;
          }
        });
      }else{
        const mobileFolders = document.querySelectorAll(".foldersWrap.mobile .foldersWrapContainer");
        let globalIndex = 0;

        console.log("mobile");

        // EqualHeight(".foldersWrap.mobile .folderContent");

        mobileFolders.forEach(container => {
          const folderTagInners = container.querySelectorAll(".folderTagInner");
          const folderContent = container.querySelectorAll(".folderContent");

          
          folderTagInners.forEach((item, index) => {
            const color = getColorByIndex(globalIndex, folderSequence);

            // styles
            item.style.zIndex = folderTagInners.length - index;
            item.querySelector("svg .bg").style.fill = `var(--${color})`;
            folderContent[index].style.backgroundColor = `var(--${color})`;
            item.querySelector(".cross").style.backgroundColor = `var(--${color})`;

            // click handler
            item.addEventListener("click", () => {
              folderTagInners.forEach((el, i) => {
                el.classList.toggle("active", i === index);
                folderContent[i].classList.toggle("active", i === index);
              });
            });

            if (index !== 0) {
              item.style.left = `-${index * 25}px`;
              // item.style.paddingLeft = `${index * 30}px`;
            }

            globalIndex++; // ✅ only for colors
          });
        });
      }

      const accordian = document.querySelectorAll(".about_product .faq");
      accordian.forEach((item) => {
        item.addEventListener("click", () => {
          item.classList.toggle("active");
        });
      });
    }

    if ($("#flipbook").length) {
      let height = 500;
      let width = 800;

      if(window.outerWidth <= 1024){
        height = 350;
        width = 500;
      }
      if(window.outerWidth <= 600){
        height = 250;
        width = 500;
      }

      $("#flipbook").turn({
        width: width,
        height: height,
        autoCenter: true,
        size: "stretch",
        maxShadowOpacity: 0.5, // Half shadow intensity
        showCover: true,
        mobileScrollSupport: false, // disable content scrolling on mobile devices
        // page: 2
      });

      const gubb_diaries = document.querySelector(".gubb_diaries");
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.intersectionRatio >= 0.5) {
            gubb_diaries.classList.add('active');
            $("#flipbook").turn("page", 2);
          } else {
            gubb_diaries.classList.remove('active'); // optional
            $("#flipbook").turn("page", 1);
          }
        },
        {
          threshold: 0.5
        }
      );
      observer.observe(gubb_diaries);
    }

    if ($(".shop_by_slider").length) {
      const shop_by_slider = new Swiper(".shop_by_slider", {
        grabCursor: true,
        loop: true,
        slidesPerView: 2,
        spaceBetween: 22,
        navigation: {
          nextEl: ".shop_by .sliderArr.right",
          prevEl: ".shop_by .sliderArr.left",
        },
        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false,
        // },
        breakpoints: {
          600: { slidesPerView: 2 },
          1024: { slidesPerView: 4 },
        },
      });
    }

    if ($(".about_tools_slider").length) {
      const folderSequence = [
        "color_pink_light",
        "color_green_light",
        "color_purple_light",
        "color_yellow_light",
      ];
      const about_tools_slides = document.querySelectorAll(".about_tools_slide");
      about_tools_slides.forEach((item, index) => {
        const colorIndex = index % folderSequence.length;
        item.style.border = `5px solid var(--${folderSequence[colorIndex]})`;
      });
      const about_tools_slider = new Swiper(".about_tools_slider", {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        initialSlide: 2,
        // loop: true,
        slidesPerView: "auto",
        slideToClickedSlide: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 150,
          depth: 150,
          modifier: 1,
          slideShadows: true,
        },
        navigation: {
          nextEl: ".about_tools .sliderArr.right",
          prevEl: ".about_tools .sliderArr.left",
        },
      });
    }

    if ($(".about_group").length) {
      const folders = document.querySelectorAll(".about_group .folder");
      const folderContents = document.querySelectorAll(
        ".about_group .folder_content"
      );

      folders.forEach((item, index) => {
        item.addEventListener("click", () => {
          folders.forEach((item2, index2) => {
            if (index2 === index) {
              item2.classList.add("active");
              folderContents[index2].classList.add("active");
            } else {
              item2.classList.remove("active");
              folderContents[index2].classList.remove("active");
            }
          });
        });
      });
    }

  if ($(".founderfav").length) {
    const allImages = document.querySelectorAll(".founderfav .folderImage img");
    const section = document.querySelector(".founderfav");

    allImages.forEach(img => {
      img.addEventListener("mouseenter", () => {
        // Remove active from all
        allImages.forEach(i => i.classList.remove("active"));

        // Add active to hovered image
        img.classList.add("active");
      });
    });
  }

    const accordian = document.querySelectorAll("footer .faq");
    accordian.forEach((item) => {
      item.addEventListener("click", () => {
        item.classList.toggle("active");
      });
    });
})


function EqualHeight(selector) {
  const elements = document.querySelectorAll(selector);
  if (!elements.length) return;

  // Reset heights first (important when calling on resize)
  elements.forEach((el) => (el.style.height = "auto"));

  // Find max height
  let maxHeight = 0;
  elements.forEach((el) => {
    const h = el.offsetHeight;
    if (h > maxHeight) maxHeight = h;
  });

  // Apply the max height
  elements.forEach((el) => (el.style.height = maxHeight + "px"));
}

function EqualWidth(selector) {
  const elements = document.querySelectorAll(selector);
  if (!elements.length) return;

  // Reset width first (important for resize recalculations)
  elements.forEach((el) => (el.style.width = "auto"));

  // Find max width
  let maxWidth = 0;
  elements.forEach((el) => {
    const w = el.offsetWidth;
    if (w > maxWidth) maxWidth = w;
  });

  // Apply the max width
  elements.forEach((el) => {
    el.style.width = maxWidth + "px";
    el.style.maxWidth = maxWidth + "px";
    el.style.minWidth = maxWidth + "px";
  });
}
